import React, { useRef, useState } from "react";
import { Stage, Layer, Line } from "react-konva";
import { useSetRecoilState } from "recoil";
import { signFileState } from "../../../recoil/receipt";
import Modal from "../layout/Modal";

interface Props {
  isOpen: Boolean;
  setIsOpen: any;
  setDrawCheck: any;
}
const DrawSign: React.FC<Props> = ({ isOpen, setIsOpen, setDrawCheck }) => {
  const setSignFile = useSetRecoilState(signFileState);
  const [tool, setTool] = useState("pen");
  const [lines, setLines] = useState<any[]>([]);
  const isDrawing = useRef(false);
  const stageRef = useRef<any>(null);

  const handleMouseDown = (e: any) => {
    isDrawing.current = true;
    const pos = e.target.getStage().getPointerPosition();
    setLines([...lines, { tool, points: [pos.x, pos.y] }]);
  };

  const handleMouseMove = (e: any) => {
    // no drawing - skipping
    if (!isDrawing.current) {
      return;
    }
    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    let lastLine = lines[lines.length - 1];
    // add point
    lastLine.points = lastLine.points.concat([point.x, point.y]);

    // replace last
    lines.splice(lines.length - 1, 1, lastLine);
    setLines(lines.concat());
  };

  const handleMouseUp = () => {
    isDrawing.current = false;
  };

  const handleExport = () => {
    //base64 이미지가 uri 로 저장됨
    const uri = stageRef.current.toDataURL();
    setSignFile(uri);
    setDrawCheck(false);
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen}>
      <div
        className="modal fade confirm-content sign-insert-modal"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header sign-top flex">
              <div className="empty"></div>
              <p className="sign-top-title" id="staticBackdropLabel">
                서명 입력
              </p>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setIsOpen(false);
                }}
              ></button>
            </div>
            <div className="modal-body confirm-sec">
              <div className="sign-btn-top">
                <button
                  className="sign-btn sign-draw"
                  onClick={() => setTool("pen")}
                >
                  서명그리기
                </button>
                <button
                  className="sign-btn sign-clear"
                  onClick={() => setTool("eraser")}
                >
                  지우기
                </button>
              </div>
              <div style={{ border: "1px solid #eee" }}>
                <Stage
                  ref={stageRef}
                  width={640}
                  height={200}
                  onMouseDown={handleMouseDown}
                  onMousemove={handleMouseMove}
                  onMouseup={handleMouseUp}
                  //mobile event
                  onTouchStart={handleMouseDown}
                  onTouchMove={handleMouseMove}
                  onTouchEnd={handleMouseUp}
                >
                  <Layer>
                    {lines.map((line, i) => {
                      return (
                        <Line
                          key={i}
                          points={line.points}
                          stroke="black"
                          strokeWidth={line.tool === "eraser" ? 500 : 5}
                          tension={0.5}
                          lineCap="round"
                          lineJoin="round"
                          globalCompositeOperation={
                            line.tool === "eraser"
                              ? "destination-out"
                              : "source-over"
                          }
                        />
                      );
                    })}
                  </Layer>
                </Stage>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="sign-insert"
                onClick={handleExport}
              >
                입력하기
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DrawSign;
